import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckTodo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 10,
			width: 18,
			height: 20,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 18L22.954 20.046L19.2847 23.7076L16 20.429",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 11,
			x2: 19,
			y2: 11,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 21,
			y1: 11,
			x2: 24,
			y2: 11,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgCheckTodo);
export default ForwardRef;
